import firebaseAnalytics from '@react-native-firebase/analytics'

export { firebaseAnalytics }
